<template>
  <div class="mt-2">
    <template v-if="showMore && items.length > 3">
      <p v-for="item in moreItems" :key="item.id" class="caption justify-center ma-0 mt-2" style="line-height:15px;">
        {{ pVal(item.grup, "keterangan") }} - Kelas {{ pVal(item.kelas, "nama") }}
      </p>
      <a class="caption" @click="showMore = false"> Tampilkan lebih sedikit </a>
    </template>
    <template v-else-if="!showMore && items.length > 3">
      <p v-for="item in miniItems" :key="item.id" class="caption justify-center ma-0 mt-2" style="line-height:15px;">
        {{ pVal(item.grup, "keterangan") }} - Kelas {{ pVal(item.kelas, "nama") }}
      </p>
      <a class="caption" @click="showMore = true"> Tampilkan selengkapnya </a>
    </template>
    <template v-else>
      <p v-for="item in items" :key="item.id" class="caption justify-center ma-0 mt-2" style="line-height:15px;">
        {{ pVal(item.grup, "keterangan") }} - Kelas {{ pVal(item.kelas, "nama") }}
      </p>
    </template>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  data() {
    return {
      showMore: false
    };
  },
  props: {
    items: {}
  },
  computed: {
    miniItems() {
      return this.items.slice(0, 3);
    },
    moreItems() {
      return this.items;
    }
  }
};
</script>

<style>
.v-btn:before {
  opacity: 0 !important;
}

.v-ripple__container {
  opacity: 0 !important;
}
</style>
